import { render, staticRenderFns } from "./CompositionLayers.vue?vue&type=template&id=27272b9f"
import script from "./CompositionLayers.vue?vue&type=script&lang=js"
export * from "./CompositionLayers.vue?vue&type=script&lang=js"
import style0 from "./CompositionLayers.vue?vue&type=style&index=0&id=27272b9f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports